<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">公司名称</p>
        <el-input v-model="companyName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">公司地址</p>
        <el-input v-model="companyAddress" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addAccount">新增公司</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort="{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">编辑</el-button>
              <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
          class="paginationBody">
      </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="dialogFormVisible"
          :before-close="closeAdd"
          center
      >
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="公司名称" label-width=".9rem" prop="name" class="formItem">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="公司地址" label-width=".9rem" prop="address" class="formItem">
            <el-input v-model="addForm.address"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAdd">取 消</el-button>
          <el-button type="primary" @click="addEventForm">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { queryCompany, addCompany, updateCompany, deleteCompany } from '@/api/basicInfo'
import { Message } from 'element-ui'

export default {
  name: 'company',
  data () {
    return {
      loading: false,
      roleValue: '',
      roleValueList: [],
      companyValueList: [],
      stateValue: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      companyName: '',
      companyAddress: '',
      id: '',
      edit: false,
      addForm: {
        name: '',
        address: '',
        id: ''
      },
      rules: {
        name: [{ required: true, message: '请填写', trigger: 'blur' }],
        address: [{ required: true, message: '请填写', trigger: 'blur' }],
        bank: [{ required: true, message: '请填写', trigger: 'blur' }],
        account: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'companyName',
          label: '公司名称'
        },
        {
          prop: 'companyAddr',
          label: '公司地址'
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList () {
      let res = await queryCompany({
        companyName: this.companyName,
        companyAddr: this.companyAddress,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    // 新增
    addAccount () {
      this.dialogFormVisible = true
      this.edit = false
      this.eventControl = '新增公司'
    },
    // 编辑
    viewOrHandle (row) {
      this.edit = true
      this.dialogFormVisible = true
      this.eventControl = '编辑公司'
      this.addForm.name = row.companyName
      this.addForm.address = row.companyAddr
      this.addForm.id = row.id
    },
    closeAdd () {
      this.addForm = {
        name: '',
        address: '',
        id: ''
      }
      this.$refs['addForm'].resetFields()
      this.dialogFormVisible = false
    },
    addEventForm () {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            let res = await updateCompany({
              companyName: this.addForm.name,
              companyAddr: this.addForm.address,
              id: this.addForm.id
            })
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.$refs['addForm'].resetFields()
              this.dialogFormVisible = false
              this.addForm = {
                name: '',
                address: '',
                id: ''
              }
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await addCompany({
              companyName: this.addForm.name,
              companyAddr: this.addForm.address
            })
            if (res.code === 0) {
              Message.success('新增成功！')
              this.$refs['addForm'].resetFields()
              this.dialogFormVisible = false
              this.addForm = {
                name: '',
                address: '',
                id: ''
              }
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除分组
    deleteFun (row) {
      this.$confirm('此操作将删除该公司信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await deleteCompany(params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }

  .searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/

    .stateDiv {
      margin-top: 0.14rem;
      margin-left: .3rem;
      float: left;
    }

    .searchText {
      margin-top: 0.05rem;
      margin-right: 0.13rem;
      font-size: 0.2rem;
      color: #111111;
      float: left;
    }

    .inputDiv {
      width: 2.2rem;
      float: left;
    }

    .searchBtn {
      /*width: 1.20rem;*/
      /*height: 0.36rem;*/
      /*border-radius: 0.06rem;*/
      /*font-size: 0.18rem;*/
      margin-top: 0.14rem;
      margin-left: .3rem;
      /*padding-top: 0.1rem;*/
    }
  }

  .table {
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;

    .searchList {
    }

    .paginationBody {
      margin-top: .1rem;
    }
  }

  .formItem {
    width: 3.2rem;
  }

  /deep/ .el-dialog {
    width: 23% !important;
  }
</style>
